/**
 * MultiRW Utils
 * MultiRW용 유틸함수
 *
 * @since 2018-07-04
 * @author mk.ko
 */
import { i18n } from '~/plugins/i18n'
import Vue from 'vue'

const bus = new Vue()

// 메뉴 전체 경로에 대한 메뉴코드 반환
const menuPathToCode = (menuPath, child) => {
  try {
    if (!(menuPath.length > 0)) return void 0

    const menuDepth = menuPath.split('/')
    let key, nextMenuPath, result

    if (!(menuDepth.length > 1)) return void 0
    key = menuDepth[1]
    nextMenuPath = ''
    for (let i = 2; i < menuDepth.length; i++) {
      nextMenuPath += `/${menuDepth[i]}`
    }
    result = child.find(row => {
      if (row.hasOwnProperty('key')) {
        return row.key === key
      } else {
        return false
      }
    })
    if (!_.isEmpty(result)) {
      if (result.hasOwnProperty('children')) {
        return menuPathToCode(nextMenuPath, result.children)
      } else {
        return result.code
      }
    } else {
      return void 0
    }
  } catch (e) {
    window.$nuxt.$log('[Error menuPathToCode]: ', e)
    return void 0
  }
}

// 메뉴코드에 대한 메뉴 전체 경로 반환
const menuCodeToPath = (code, child) => {
  try {
    const findArr = []

    const finder = (code, child) => {
      const idx = findArr.length
      child.some(row => {
        // count++
        if (Number(row.code) === Number(code)) {
          findArr.push(row)
          // window.$nuxt.$log('######### findArr PUSH (FIND!!!)', findArr, row)
          return true
        } else if (row.hasOwnProperty('children')) {
          findArr.push(row)
          // window.$nuxt.$log('######### findArr PUSH (Searching...)', findArr, row)
          if (!finder(code, row.children)) {
            findArr.pop()
            // window.$nuxt.$log('######### findArr POP (Not this tree...)', findArr, row)
          } else {
            return true
          }
        }
        return false
      })

      return idx < findArr.length
    }
    finder(code, child)
    if (findArr.length > 0) {
      let path = ''
      findArr.forEach(depth => {
        path += `/${depth.key}`
      })
      return path
    } else {
      return void 0
    }
  } catch (e) {
    window.$nuxt.$log('[Error menuCodeToPath]: ', e)
    return void 0
  }
}

// 메뉴 전체 경로에 대한 메뉴 정보 반환
const menuPathToInfo = (menuPath, child) => {
  try {
    if (!(menuPath.length > 0)) return void 0
    let menuDepth, key, nextMenuPath, result
    menuDepth = menuPath.split('/')
    if (!(menuDepth.length > 1)) return void 0
    key = menuDepth[1]
    nextMenuPath = ''
    for (let i = 2; i < menuDepth.length; i++) {
      nextMenuPath += `/${menuDepth[i]}`
    }
    result = child.find(row => {
      if (row.hasOwnProperty('key')) {
        return row.key === key
      } else {
        return false
      }
    })
    if (_.isEmpty(result)) return void 0
    if (result.hasOwnProperty('children')) {
      return menuPathToInfo(nextMenuPath, result.children)
    } else {
      return result
    }
  } catch (e) {
    window.$nuxt.$log('[Error menuPathToInfo]: ', e, menuPath, child)
    return void 0
  }
}

// 메뉴 전체 경로에 대한 각 depth 별 정보 반환 (children 포함)
const menuPathToHierarchyInfo = (menuPath, child) => {
  try {
    const findArr = []

    const finder = (menuPath, child) => {
      if (!(menuPath.length > 0)) return false
      let menuDepth, key, nextMenuPath, result
      menuDepth = menuPath.split('/')
      if (!(menuDepth.length > 1)) return false
      key = menuDepth[1]
      nextMenuPath = ''
      for (let i = 2; i < menuDepth.length; i++) {
        nextMenuPath += `/${menuDepth[i]}`
      }
      result = child.find(row => {
        if (row.hasOwnProperty('key')) {
          return row.key === key
        } else {
          return false
        }
      })
      if (!_.isEmpty(result)) {
        findArr.push(result)
        if (result.hasOwnProperty('children')) {
          return finder(nextMenuPath, result.children)
        } else {
          return true
        }
      } else {
        return false
      }
    }

    finder(menuPath, child)
    if (findArr.length > 0) {
      return findArr
    } else {
      return void 0
    }
  } catch (e) {
    window.$nuxt.$log('[Error menuPathToHierarchyInfo]: ', e)
    return void 0
  }
}

// 메뉴코드에 대한 메뉴 정보 반환
const menuCodeToHierarchyInfo = (code, child) => {
  try {
    const findArr = []

    const finder = (code, child) => {
      const idx = findArr.length
      child.some(row => {
        // count++
        if (Number(row.code) === Number(code)) {
          findArr.push(row)
          // window.$nuxt.$log('######### findArr PUSH (FIND!!!)', findArr, row)
          return true
        } else if (row.hasOwnProperty('children')) {
          findArr.push(row)
          // window.$nuxt.$log('######### findArr PUSH (Searching...)', findArr, row)
          if (!finder(code, row.children)) {
            findArr.pop()
            // window.$nuxt.$log('######### findArr POP (Not this tree...)', findArr, row)
          } else {
            return true
          }
        }
        return false
      })

      return idx < findArr.length
    }
    finder(code, child)
    if (findArr.length > 0) {
      return findArr
    } else {
      return void 0
    }
  } catch (e) {
    window.$nuxt.$log('[Error menuCodeToHierarchyInfo]: ', e)
    return void 0
  }
}

const multirwChecker = (config = {}) => {
  let defaultConfig = {
    tryCount: 0,
    limitCount: 10,
    result: void 0,
    callback: () => {
      if (typeof config.callback === 'function') {
        config.callback()
      }
    },
    error: () => {
      if (typeof config.error === 'function') {
        config.error(i18n.t('msg.failReason_timout'))
      } else {
        window.$nuxt.$log('Check-In timeout')
      }
    }
  }

  defaultConfig.finish = false // finally overwrite
  if (typeof config.tryCount !== 'undefined') {
    defaultConfig.tryCount = parseInt(config.tryCount)
  }
  if (typeof config.limitCount !== 'undefined') {
    defaultConfig.limitCount = parseInt(config.limitCount)
  }

  // window.$nuxt.$store.state.common.common.agentTime
  bus.$emit('check-in', defaultConfig) // call-by-reference
  let interval = setInterval(() => {
    defaultConfig.tryCount++
    if (defaultConfig.finish) {
      clearInterval(interval)
      if (defaultConfig.result) {
        defaultConfig.callback() // success
      }
      interval = null
      defaultConfig = null
    } else if (defaultConfig.tryCount >= defaultConfig.limitCount) {
      clearInterval(interval)
      defaultConfig.error() // timeout
      interval = null
      defaultConfig = null
    }
  }, 1000)
}

const afterCheckIn = (config = {}) => {
  if (!window.$nuxt.$store.state.common.multirw.isCheckIn) {
    multirwChecker(config)
  } else {
    if (typeof config.callback === 'function') {
      config.callback()
    }
  }
}

const afterCheckOut = (config = {}) => {
  if (window.$nuxt.$store.state.common.multirw.isCheckIn) {
    multirwChecker(config)
  } else {
    if (typeof config.callback === 'function') {
      config.callback()
    }
  }
}

// 장비 ID에 대한 전체 상속 구조 반환
const deviceToHierarchyInfo = (deviceId, child) => {
  try {
    const findArr = []

    const finder = (deviceId, child) => {
      const idx = findArr.length
      child.some(row => {
        // count++
        if (Number(row.device_id) === Number(deviceId)) {
          findArr.push(row)
          // window.$nuxt.$log('######### findArr PUSH (FIND!!!)', findArr, row)
          return true
        } else if (row.hasOwnProperty('children')) {
          findArr.push(row)
          // window.$nuxt.$log('######### findArr PUSH (Searching...)', findArr, row)
          if (!finder(deviceId, row.children)) {
            findArr.pop()
            // window.$nuxt.$log('######### findArr POP (Not this tree...)', findArr, row)
          } else {
            return true
          }
        }
        return false
      })

      return idx < findArr.length
    }
    finder(deviceId, child)
    return findArr
  } catch (e) {
    window.$nuxt.$log('[Error deviceToHierarchyInfo]: ', e)
    return void 0
  }
}

export {
  bus,
  afterCheckIn,
  afterCheckOut,
  menuPathToCode,
  menuPathToInfo,
  menuPathToHierarchyInfo,
  menuCodeToPath,
  menuCodeToHierarchyInfo,
  deviceToHierarchyInfo
}
